var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 12.168L13.1297 3.41797H29.1635C29.9706 3.41797 30.625 4.08196 30.625 4.86434V31.1383C30.625 31.9371 29.9762 32.5846 29.1763 32.5846H5.82371C5.02361 32.5846 4.375 31.9285 4.375 31.1164V12.168ZM14.5833 6.33464V13.6263H7.29167V29.668H27.7083V6.33464H14.5833Z",
    fill: "#00B0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.d8515ddb2f7fef4c2936a748afa38a93.svg";
export { ForwardRef as ReactComponent };